import Login from './Login'
import SelecionarPerfil from './SelecionarPerfil'
import AdministradorAcesso from '@/screens/portal/seguranca/AdministradorAcesso.vue'
import AdministrarAssinaturas from '@/screens/portal/seguranca/AdministrarAssinaturas.vue'
import CadastrarSenha from '@/screens/portal/seguranca/CadastrarSenha.vue'
import CadastroUsuario from '@/screens/portal/seguranca/CadastroUsuario.vue'
import SelecionarModulo from './SelecionarModulo'
import store from '@/store'

const beforeEnter = async (to, from, next) => {
  const usuario = await store.dispatch('auth/getUsuario')

  if (usuario) {
    next('/selecionarModulo')
  } else {
    next()
  }
}

export const items = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { isPublic: true },
    beforeEnter: beforeEnter
  },
  {
    path: '/selecionarModulo',
    name: 'selecionarModulo',
    component: SelecionarModulo
  },
  {
    path: '/selecionarPerfil',
    name: 'selecionarPerfil',
    component: SelecionarPerfil
  },
  {
    path: '/administradorAcesso',
    name: 'portalSeguranca/administradorAcesso',
    component: AdministradorAcesso
  },
  {
    path: '/administrarAssinaturas',
    name: 'portalSeguranca/administrarAssinaturas',
    component: AdministrarAssinaturas
  },
  {
    path: '/cadastroUsuario/:tipo',
    name: 'cadastroUsuario',
    component: CadastroUsuario,
    meta: { isPublic: true }
  },
  {
    path: '/editarUsuario/:cpfCnpj',
    name: 'editarUsuario',
    component: CadastroUsuario
  },
  {
    path: '/cadastrarSenha/:codigo',
    name: 'cadastrarSenha',
    // TROCAR ESSA ROTA PRO BAGULHO CERTO
    component: CadastrarSenha,
    meta: { isPublic: true }
  }

]



// WEBPACK FOOTER //
// ./src/screens/portal/seguranca/config.js